var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.status},[_c('StepsComponent',{attrs:{"stepsTitles":this.$props.stepsTitles,"subtitlesSteps":this.$props.subtitlesSteps,"currentStep":this.$props.currentStep}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }